import { Skeleton } from '@mui/material';
import React, { FC } from 'react';

import translate from '../../../../i18n/translate';

export const amountDefault = 2;
const heightDefault = 42;

type Props = {
  amount?: number;
  height?: number;
};

/**
 * Skeleton list for CheckboxList
 *
 * @param props        Props passed to the component
 * @param props.amount The number of skeletons to display
 * @param props.height The height of the skeleton
 * @returns            The component itself
 */
const CheckboxListSkeleton: FC<Props> = ({
  amount = amountDefault,
  height = heightDefault,
}) => {
  return Array.from({ length: amount }).map((_el, index) => (
    <Skeleton
      animation="wave"
      aria-label={translate('PLACEHOLDER__LOADING')}
      height={height}
      // eslint-disable-next-line react/no-array-index-key
      key={index}
      variant="rounded"
    />
  ));
};

export default CheckboxListSkeleton;
